var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 99.5,
    fill: "url(#paint0_linear_7502_51286)",
    stroke: "#27272A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.544 80.5368L148.434 57.8122C121.609 36.5266 80.6364 37.8603 57.0492 64.4295C49.232 73.2351 44.2061 84.7227 43.6259 98.6576C42.8187 118.045 51.5272 136 65.1029 145.638C90.7819 163.867 125.354 159.468 149.997 142.187L134.899 118.121C116.778 132.215 83.5069 130.872 81.2077 102.684C78.9084 74.4967 110.067 66.4429 131.544 80.5368Z",
    fill: "#FAFAFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7502_51286",
    x1: 140,
    y1: 174,
    x2: 40,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCara);
export default __webpack_public_path__ + "static/media/cara.b2057b4bad69fff958ab0935458423e7.svg";
export { ForwardRef as ReactComponent };